module.exports = __webpack_public_path__ + "img/vertical_6_2_7005.038450b8.png";